// extracted by mini-css-extract-plugin
module.exports = {"header":"dashboard-header_header__xtGyF","brand":"dashboard-header_brand__Kp43Q","navigation":"dashboard-header_navigation__Jj71u","actions":"dashboard-header_actions__QMUkt"};